<div class="app-container">
  @if (showHeader) {
    <app-header />
  }
  <div class="router-container" [class.dark-mode]="user.darkMode()">
    <router-outlet />
  </div>

  <tour-step-template />

  <!-- Anchor para o primeiro step do tour V2  PODIA TAR NO MAPA?-->
  <div class="centered-tour-element" tourAnchor="welcome-step"></div>
  <!-- Anchor para o último step do tour V2 -->
  <div class="centered-tour-element" tourAnchor="links-step"></div>
</div>
